module.exports = __webpack_public_path__ + "img/carebox.f3c300bf.svg";